/**
 * The fields that identify a suburb. Components announce the same suburb in
 * different shapes (some add `fullName` or `state`, some leave them empty), so
 * only the name and postcode decide whether two payloads are the same place.
 */
export interface SuburbIdentity {
  name?: string | null;
  postcode?: string | null;
}

const normaliseSuburbField = (value?: string | null): string =>
  (value ?? '').trim().toLowerCase();

/**
 * True when both payloads name the same suburb, regardless of their shape.
 * A missing suburb or a missing postcode never matches.
 */
export const isSameSuburb = (
  first?: SuburbIdentity | null,
  second?: SuburbIdentity | null
): boolean => {
  if (!first || !second) return false;

  const firstPostcode = normaliseSuburbField(first.postcode);
  if (firstPostcode === '') return false;

  return (
    firstPostcode === normaliseSuburbField(second.postcode) &&
    normaliseSuburbField(first.name) === normaliseSuburbField(second.name)
  );
};
